import React, { SVGProps } from "react";
const SvgBeautyCareAndSpa = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={29.512} viewBox="0 0 29.512 28.449" {...props}>
      <g data-name="Beauty, care and Spa">
        <path
          data-name="Path 639"
          d="M14.25 3.396a9.368 9.368 0 0 1 3.972.828 3.976 3.976 0 0 0-7.944 0 9.368 9.368 0 0 1 3.972-.828Zm0 0"
          fill="#b57a4e"
        />
        <path
          data-name="Path 640"
          d="M12.184 3.6A3.968 3.968 0 0 1 15.165.536a4.008 4.008 0 0 0-.915-.1 3.965 3.965 0 0 0-3.972 3.792 8.517 8.517 0 0 1 1.906-.624Zm0 0"
          fill="#9b5729"
        />
        <path
          data-name="Path 641"
          d="M23.531 26.004a2.715 2.715 0 0 1-1.778-.789l-3.285-3.266h-1.186l-3.032 4.643-3.032-4.643h-2a4.249 4.249 0 0 0-4.257 4.232v1.536a.3.3 0 0 0 .3.3h17.978a.3.3 0 0 0 .3-.3v-1.711Zm0 0"
          fill="#12b05e"
        />
        <path
          data-name="Path 642"
          d="m9.648 22.183-.152-.233h-.281a4.249 4.249 0 0 0-4.257 4.231v1.536a.3.3 0 0 0 .3.3H7.08a.3.3 0 0 1-.3-.3v-1.534a4.24 4.24 0 0 1 2.868-4Zm0 0"
          fill="#03984b"
        />
        <path
          data-name="Path 643"
          d="M18.472 21.948h-1.191l-3.032 4.643-3.032-4.643H9.496l3.547 5.431a1.442 1.442 0 0 0 1 .638h.411a1.442 1.442 0 0 0 1-.638l3.338-5.111Zm0 0"
          fill="#def9ff"
        />
        <path
          data-name="Path 644"
          d="M15.972 21.538v-1.181a5.734 5.734 0 0 1-.975.083h-1.493a5.737 5.737 0 0 1-.975-.083v1.181a.409.409 0 0 1-.409.407h-.9l3.032 4.643 3.032-4.643h-.9a.409.409 0 0 1-.412-.407Zm0 0"
          fill="#f8d5ab"
        />
        <path
          data-name="Path 645"
          d="M12.398 21.838a.408.408 0 0 1-.279.11h-.9l3.032 4.643.626-.959Zm0 0"
          fill="#eac092"
        />
        <path
          data-name="Path 646"
          d="M14.249 3.396c-4.229 0-7.657 2.409-7.657 6.566v1.981a1.2 1.2 0 0 1 .313-.042h.966v-1.3a.326.326 0 0 1 .327-.325h5.056a2.762 2.762 0 0 0 2.319-1.283.328.328 0 0 1 .554 0 2.762 2.762 0 0 0 2.319 1.283h1.855a.326.326 0 0 1 .327.325v1.3h.967a1.2 1.2 0 0 1 .312.042V9.962c0-4.157-3.428-6.566-7.657-6.566Zm0 0"
          fill="#b57a4e"
        />
        <path
          data-name="Path 647"
          d="M14.249 3.396c-4.229 0-7.657 2.409-7.657 6.566v1.981a1.2 1.2 0 0 1 .313-.042h.966v-1.3a.326.326 0 0 1 .327-.325h.218v-.314c0-3.854 2.946-6.2 6.746-6.527q-.449-.038-.912-.038Zm0 0"
          fill="#9b5729"
        />
        <g data-name="Group 189" fill="#ffe2b8">
          <path
            data-name="Path 648"
            d="M22.464 15.279a1.152 1.152 0 0 0 .319-.795V13.07a1.178 1.178 0 0 0-1.188-1.168h-.938v2.283a2.592 2.592 0 0 1 1.807 1.094Zm0 0"
          />
          <path
            data-name="Path 649"
            d="M6.231 15.445a.32.32 0 0 1 .238-.256 4.255 4.255 0 0 1 1.379-.119c0-.077-.005-.155-.005-.233v-2.936h-.938a1.178 1.178 0 0 0-1.188 1.168v1.414a1.161 1.161 0 0 0 .514.962Zm0 0"
          />
          <path
            data-name="Path 650"
            d="M18.043 19.107a.6.6 0 0 1 .125-.951 2.551 2.551 0 0 1-.428-1.417 2.583 2.583 0 0 1 2.59-2.575 2.657 2.657 0 0 1 .327.021v-3.582a.355.355 0 0 0-.356-.354h-1.855a2.734 2.734 0 0 1-2.295-1.269.357.357 0 0 0-.6 0 2.734 2.734 0 0 1-2.295 1.269H8.2a.355.355 0 0 0-.356.354l.005 4.468a3.565 3.565 0 0 1 2.245 1.008 3.718 3.718 0 0 1 .894 3.6.318.318 0 0 1-.077.139 5.669 5.669 0 0 0 2.594.624h1.493a5.665 5.665 0 0 0 3.318-1.067Zm0 0"
          />
        </g>
        <path
          data-name="Path 651"
          d="M9.405 10.252H8.198a.355.355 0 0 0-.356.354l.005 4.468a3.731 3.731 0 0 1 1.229.312q-.026-.269-.027-.545v-4.235a.355.355 0 0 1 .356-.354Zm0 0"
          fill="#ffc987"
        />
        <path
          data-name="Path 652"
          d="M25.706 11.002a.168.168 0 0 1-.156-.106 2.06 2.06 0 0 0-1.447-1.447.168.168 0 0 1 0-.313 2.059 2.059 0 0 0 1.447-1.447.168.168 0 0 1 .313 0 2.06 2.06 0 0 0 1.447 1.447.168.168 0 0 1 0 .313 2.06 2.06 0 0 0-1.447 1.447.168.168 0 0 1-.157.106Zm0 0"
          fill="#ffaf10"
        />
        <path
          data-name="Path 653"
          d="m24.702 8.867-.015-.007a4.032 4.032 0 0 1-.583.276.168.168 0 0 0 0 .313 2.059 2.059 0 0 1 1.447 1.447.168.168 0 0 0 .313 0 3.992 3.992 0 0 1 .281-.592 2.054 2.054 0 0 0-1.443-1.437Zm0 0"
          fill="#f39600"
        />
        <path
          data-name="Path 654"
          d="M3.575 11.019a.168.168 0 0 1-.156-.106 2.059 2.059 0 0 0-1.447-1.447.168.168 0 0 1 0-.313 2.059 2.059 0 0 0 1.447-1.447.168.168 0 0 1 .313 0 2.059 2.059 0 0 0 1.447 1.447.168.168 0 0 1 0 .313 2.059 2.059 0 0 0-1.447 1.447.168.168 0 0 1-.157.106Zm0 0"
          fill="#ffcb00"
        />
        <path
          data-name="Path 655"
          d="m2.567 8.885-.013-.007a4.071 4.071 0 0 1-.582.275.168.168 0 0 0 0 .313 2.059 2.059 0 0 1 1.447 1.447.168.168 0 0 0 .313 0 4.021 4.021 0 0 1 .279-.589 2.055 2.055 0 0 0-1.444-1.439Zm0 0"
          fill="#ffaf10"
        />
        <path
          data-name="Path 656"
          d="M6.047 4.13a.136.136 0 0 1-.127-.086 1.67 1.67 0 0 0-1.173-1.173.136.136 0 0 1 0-.254A1.67 1.67 0 0 0 5.92 1.444a.136.136 0 0 1 .253 0 1.67 1.67 0 0 0 1.173 1.173.136.136 0 0 1 0 .254 1.67 1.67 0 0 0-1.173 1.173.136.136 0 0 1-.126.086Zm0 0"
          fill="#ffaf10"
        />
        <path
          data-name="Path 657"
          d="M6.5 3.423a1.644 1.644 0 0 0-1.106-1.142 2.43 2.43 0 0 1-.646.345.136.136 0 0 0 0 .253 1.67 1.67 0 0 1 1.173 1.174.136.136 0 0 0 .253 0 2.526 2.526 0 0 1 .327-.624Zm0 0"
          fill="#f39600"
        />
        <path
          data-name="Path 658"
          d="m5.224 19.663-4.633 5.1a.536.536 0 0 0 0 .762.544.544 0 0 0 .766 0l5.126-4.605Zm0 0"
          fill="#c7c8ca"
        />
        <path
          data-name="Path 659"
          d="m5.71 20.15-.485-.483-4.633 5.1a.536.536 0 0 0 0 .762.544.544 0 0 0 .766 0l.233-.21a.536.536 0 0 1 .055-.7Zm0 0"
          fill="#a7a9ac"
        />
        <path
          data-name="Path 660"
          d="M10.093 16.078a3.772 3.772 0 0 0-3.624-.889.321.321 0 0 0-.243.29l-.2 3.02 1.631 1.621 3.038-.2a.322.322 0 0 0 .291-.241 3.718 3.718 0 0 0-.893-3.601Zm0 0"
          fill="#9b5729"
        />
        <path
          data-name="Path 661"
          d="M7.398 15.493a3.908 3.908 0 0 0-.747.1l-.19 2.882.832-1.392Zm0 0"
          fill="#7f441c"
        />
        <path
          data-name="Path 662"
          d="M7.142 21.158a.291.291 0 0 1-.409 0l-1.755-1.744a.287.287 0 0 1 0-.406l.578-.574a.291.291 0 0 1 .409 0l1.755 1.744a.287.287 0 0 1 0 .406Zm0 0"
          fill="#8a8c8e"
        />
        <path
          data-name="Path 663"
          d="m5.677 19.784.647-.643a.323.323 0 0 1 .259-.091l-.617-.613a.291.291 0 0 0-.409 0l-.578.575a.287.287 0 0 0 0 .406l.605.6a.319.319 0 0 1 .094-.235Zm0 0"
          fill="#6d6e71"
        />
        <path
          data-name="Path 664"
          d="M20.329 14.596a2.153 2.153 0 0 0-2.158 2.143 2.119 2.119 0 0 0 .2.907h.1a.123.123 0 1 0 .172-.169 1.042 1.042 0 0 1 1.777-.735l.224.222a1.043 1.043 0 0 1 1.774-.65l.03.03a2.157 2.157 0 0 0-2.119-1.748Zm0 0"
          fill="#ff99a3"
        />
        <path
          data-name="Path 665"
          d="M18.473 17.641a.123.123 0 1 0 .172-.169 1.027 1.027 0 0 1 .268-.694v-.04a2.579 2.579 0 0 1 2-2.508 2.611 2.611 0 0 0-.587-.067 2.583 2.583 0 0 0-2.59 2.575 2.552 2.552 0 0 0 .22 1.038 1.038 1.038 0 0 1 .517-.135Zm0 0"
          fill="#f66"
        />
        <path
          data-name="Path 666"
          d="M26.662 28.017a.316.316 0 0 1-.223-.092l-2.026-2.014a2.768 2.768 0 0 1-.726.1 2.719 2.719 0 0 1-1.929-.794l-4.146-4.122a.6.6 0 0 1 0-.857.612.612 0 0 1 .862 0l2.35 2.336.352-.35-3.133-3.114a.6.6 0 0 1 0-.856.612.612 0 0 1 .861 0l3.133 3.114.352-.35-3.133-3.114a.6.6 0 0 1 0-.857.612.612 0 0 1 .861 0l3.133 3.114.352-.35-2.35-2.336a.606.606 0 0 1 .431-1.034.608.608 0 0 1 .431.177l3.013 3v-1.081a.766.766 0 0 1 1.533 0v2.712a2.711 2.711 0 0 1 .3 2.135l2.032 2.005a.314.314 0 0 1 0 .445l-2.1 2.09a.315.315 0 0 1-.23.093Zm0 0"
          fill="#ffc987"
        />
        <path
          data-name="Path 667"
          d="M14.062 15.682h.7a.432.432 0 1 0 0-.865h-.6v-1.049a.432.432 0 0 0-.865 0v1.157a.759.759 0 0 0 .765.757Zm0 0"
        />
        <path
          data-name="Path 668"
          d="M12.519 12.436a.433.433 0 0 0-.611 0 1.469 1.469 0 0 1-2.066 0 .432.432 0 0 0-.61.613 2.336 2.336 0 0 0 3.285 0 .432.432 0 0 0 .002-.613Zm0 0"
        />
        <path
          data-name="Path 669"
          d="M17.625 13.723a2.323 2.323 0 0 0 1.643-.675.432.432 0 0 0-.609-.613 1.469 1.469 0 0 1-2.066 0 .432.432 0 0 0-.61.613 2.322 2.322 0 0 0 1.642.675Zm0 0"
        />
        <path
          data-name="Path 670"
          d="M11.959 16.642a.432.432 0 0 0 0 .611 3.219 3.219 0 0 0 2.277.935 3.254 3.254 0 0 0 2.3-.947.432.432 0 0 0-.61-.613 2.387 2.387 0 0 1-3.358.012.432.432 0 0 0-.609.002Zm0 0"
        />
        <path
          data-name="Path 671"
          d="M23.948 9.851a1.649 1.649 0 0 1 1.2 1.2.6.6 0 0 0 1.116 0 1.65 1.65 0 0 1 1.2-1.2.6.6 0 0 0 0-1.116 1.65 1.65 0 0 1-1.2-1.205.6.6 0 0 0-1.116 0 1.65 1.65 0 0 1-1.2 1.2.6.6 0 0 0 0 1.116Zm1.763-1.465a2.086 2.086 0 0 0 .907.907.907.907 0 0 1-1.814 0 2.085 2.085 0 0 0 .902-.907Zm0 0"
        />
        <path
          data-name="Path 672"
          d="M1.813 9.868a1.65 1.65 0 0 1 1.2 1.2.6.6 0 0 0 1.116 0 1.65 1.65 0 0 1 1.2-1.205.6.6 0 0 0 0-1.116 1.65 1.65 0 0 1-1.2-1.205.6.6 0 0 0-1.116 0 1.651 1.651 0 0 1-1.205 1.205.6.6 0 0 0 0 1.116Zm1.763-1.465a2.086 2.086 0 0 0 .907.907 2.086 2.086 0 0 0-.907.907 2.086 2.086 0 0 0-.907-.907 2.086 2.086 0 0 0 .907-.907Zm0 0"
        />
        <path
          data-name="Path 673"
          d="M4.588 3.278a1.263 1.263 0 0 1 .931.931.569.569 0 0 0 1.057 0 1.264 1.264 0 0 1 .931-.931.569.569 0 0 0 0-1.057 1.264 1.264 0 0 1-.931-.931.569.569 0 0 0-1.057 0 1.265 1.265 0 0 1-.932.931.569.569 0 0 0 0 1.057Zm1.459-1.1a1.684 1.684 0 0 0 .571.571 1.685 1.685 0 0 0-.571.571 1.681 1.681 0 0 0-.571-.571 1.681 1.681 0 0 0 .571-.571Zm0 0"
        />
        <path
          data-name="Path 674"
          d="m29.292 25.083-.282-.28a.432.432 0 0 0-.61.613l.2.2-1.936 1.925-1.946-1.941a.432.432 0 0 0-.418-.111 2.334 2.334 0 0 1-.612.082 2.289 2.289 0 0 1-1.624-.668l-4.146-4.122a.171.171 0 0 1 0-.243.182.182 0 0 1 .252 0l2.35 2.336a.432.432 0 0 0 .61 0l.352-.35a.432.432 0 0 0 0-.613L18.347 18.8a.171.171 0 0 1 0-.243.182.182 0 0 1 .252 0l3.133 3.114a.432.432 0 0 0 .61 0l.352-.35a.432.432 0 0 0 0-.613l-3.133-3.114a.171.171 0 0 1 0-.243.182.182 0 0 1 .252 0l3.133 3.114a.432.432 0 0 0 .61 0l.352-.35a.432.432 0 0 0 0-.613l-2.35-2.336a.171.171 0 0 1 0-.243.182.182 0 0 1 .252 0l3.013 3a.432.432 0 0 0 .737-.307V18.53a.334.334 0 0 1 .668 0v2.712a.431.431 0 0 0 .064.227 2.277 2.277 0 0 1 .253 1.793.432.432 0 0 0 .112.422l.3.3a.432.432 0 1 0 .61-.613l-.131-.131a3.147 3.147 0 0 0-.345-2.115V18.53a1.2 1.2 0 0 0-2.4 0v.042L23.316 17.2a2.983 2.983 0 0 0-.331-1.9 1.576 1.576 0 0 0 .229-.819V13.07a1.6 1.6 0 0 0-.876-1.421V9.963a6.433 6.433 0 0 0-2.4-5.178 7.344 7.344 0 0 0-1.3-.837 4.411 4.411 0 0 0-8.773 0 7.334 7.334 0 0 0-1.3.837 6.433 6.433 0 0 0-2.4 5.178v1.687a1.6 1.6 0 0 0-.875 1.421v1.414a1.586 1.586 0 0 0 .5 1.152l-.152 2.3a.714.714 0 0 0-.38.2l-.578.575a.719.719 0 0 0-.045.97L.277 24.461a.971.971 0 0 0 .7 1.65.97.97 0 0 0 .679-.275l4.814-4.328a.722.722 0 0 0 .976-.038l.578-.575a.715.715 0 0 0 .2-.378l2.5-.163a.754.754 0 0 0 .206-.043 6.1 6.1 0 0 0 1.166.4v.8H9.215a4.682 4.682 0 0 0-4.689 4.669v1.536a.735.735 0 0 0 .734.734h17.978a.735.735 0 0 0 .734-.734v-1.289c.1-.009.2-.023.3-.042l1.858 1.847a.748.748 0 0 0 1.054 0l2.1-2.091a.747.747 0 0 0 0-1.059ZM16.4 20.713a6 6 0 0 0 .606-.176 1.081 1.081 0 0 0-.009.127 1.03 1.03 0 0 0 .306.735l.118.117H16.4Zm6.016-4.4a1.042 1.042 0 0 0-1.774.65l-.224-.222a1.041 1.041 0 0 0-1.777.735 1.061 1.061 0 0 0 .016.186 1.053 1.053 0 0 0-.189-.017h-.1a2.116 2.116 0 0 1-.2-.907 2.159 2.159 0 0 1 4.278-.4Zm-.07-1.826v.02a3.025 3.025 0 0 0-1.26-.676v-1.497h.505a.747.747 0 0 1 .756.736ZM14.25.865a3.545 3.545 0 0 1 3.44 2.675 10.569 10.569 0 0 0-6.88 0A3.546 3.546 0 0 1 14.25.865Zm-8.1 12.2a.747.747 0 0 1 .756-.736h.504v2.293a4.773 4.773 0 0 0-1.047.143.752.752 0 0 0-.131.047.714.714 0 0 1-.083-.333ZM1.069 25.2l-.016.015a.112.112 0 0 1-.157 0 .1.1 0 0 1 0-.149l.015-.016 4.329-4.762.614.611Zm5.868-4.442-1.55-1.541.374-.371 1.55 1.541Zm3.649-1.258-2.763.18-.044-.043 1.549-.915a.432.432 0 0 0-.44-.744L7.155 19l1.028-1.719a.432.432 0 1 0-.742-.444l-.923 1.544-.047-.047.181-2.741a3.874 3.874 0 0 1 .868-.1 3.181 3.181 0 0 1 2.268.9 3.275 3.275 0 0 1 .8 3.11Zm-.186-3.728a3.95 3.95 0 0 0-2.125-1.082v-4.009h1.7a.432.432 0 1 0 0-.865H8.2a.788.788 0 0 0-.788.786v.866h-.387V9.962a5.6 5.6 0 0 1 2.082-4.506 8.166 8.166 0 0 1 5.143-1.628 8.165 8.165 0 0 1 5.142 1.628 5.6 5.6 0 0 1 2.082 4.506v1.507h-.385V10.6a.788.788 0 0 0-.788-.786h-1.855a2.3 2.3 0 0 1-1.928-1.064.789.789 0 0 0-1.335 0 2.3 2.3 0 0 1-1.929 1.067h-1.265a.432.432 0 1 0 0 .865h1.264a3.17 3.17 0 0 0 2.6-1.373 3.171 3.171 0 0 0 2.6 1.373h1.778v3.052a3.018 3.018 0 0 0-2.917 3 2.974 2.974 0 0 0 .318 1.339 1.03 1.03 0 0 0 .008 1.227 5.234 5.234 0 0 1-2.64.712h-1.5a5.244 5.244 0 0 1-2.05-.412 4.117 4.117 0 0 0-1.05-3.828Zm1.722 6.609a.841.841 0 0 0 .842-.839v-.689c.179.016.36.024.543.024H15q.274 0 .543-.024v.689a.841.841 0 0 0 .842.839h.1L14.25 25.8l-2.234-3.42Zm-6.728 5.2v-1.4a3.816 3.816 0 0 1 3.824-3.8h.047l3.4 5.2Zm10.447 0L16.8 26.1a.432.432 0 0 0-.724-.473l-.987 1.511a1.008 1.008 0 0 1-.673.442h-.343a1.008 1.008 0 0 1-.673-.442l-3.11-4.762h.689l2.9 4.447a.433.433 0 0 0 .724 0l2.9-4.447h.697l-1.032 1.58a.432.432 0 1 0 .724.473l.97-1.484 2.587 2.572a3.142 3.142 0 0 0 1.655.867v1.2Zm0 0"
        />
        <path
          data-name="Path 675"
          d="M23.687 25.575a2.333 2.333 0 0 0 .612-.082.433.433 0 0 1 .418.111l1.944 1.933.431-.429-2.1-2.09a3.049 3.049 0 0 1-.8.107 3 3 0 0 1-2.128-.876l-1.253-1.246a.431.431 0 0 1-.291-.125l-2.35-2.336a.182.182 0 0 0-.252 0 .171.171 0 0 0 0 .243l4.146 4.122a2.288 2.288 0 0 0 1.623.668Zm0 0"
          fill="#ffaf68"
        />
      </g>
    </svg>
  );
};
export default SvgBeautyCareAndSpa;
